<template>
  <div class="menu">
    <b-card class="help-menu" no-body>
      <b-card-body>
        <b-card-title class="dark-variant text-align-center">Help</b-card-title>
        <ul>
          <li>
            <router-link :to="{ name: 'Help' }" tag="li">Contact</router-link>
          </li>
          <li>
            <router-link :to="{ name: 'FeedBack' }" tag="li">Feed Back</router-link>
          </li>
          <li>
            <router-link :to="{ name: 'TermsOfUSe' }" tag="li">Terms Of Use</router-link>
          </li>
          <li>
            <router-link :to="{ name: 'FAQ' }" tag="li">FAQ</router-link>
          </li>
        </ul>
      </b-card-body>
    </b-card>
  </div>
</template>
<script>
export default {
  name: "HelpMenu",
};
</script>
<style lang="scss">
  @import '../../css/style.scss';
</style>
<style lang="scss" scoped>
/* The active item paints the row blue - keep its label readable on that fill. */
.menu .help-menu ul li .router-link-active,
.menu .help-menu ul li.router-link-active {
  background: #0066b3 !important;
  color: #fff !important;
}
</style>
